import billCreditCardApi from '@/api/billCreditCard/billCreditCardApi.js'

export default {
	name: 'bill-credit-card',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			cardNumber: null,
			cardType: null,
			selectYear: '0',
			selectMonth: '0',
			//卡號檢核與確定按鈕送出的msg不一樣,還沒按按鈕的msg為空字串
			isCardNumError: false,
			cardNumMsg:'',
			cardNumBtn: false,
			otherBtn:false,
		};
	},
	computed: {
		getThisYear(){
			let today = new Date();
			return today.getFullYear();
		},
		getMonthMin(){
			if(this.selectYear == this.getThisYear){
				let today = new Date();
				return today.getMonth()+1;
			}
			return 0;
		},
		
	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init(){
			await billCreditCardApi.permissionValidation();
		},
		async checkCreditCard(){
			await this.$validator.validate();
			this.isCardNumError = this.errors.has('cardNumber');
			this.cardNumBtn = true;
			this.cardNumMsg = this.isCardNumError? '信用卡號格式錯誤': '信用卡號格式正確';
		},
		async check(){
			//表單驗證
			const isValid = await this.$validator.validate();
			if(!isValid){
				this.isCardNumError = this.errors.has('cardNumber');
				this.otherBtn = true;
				this.cardNumMsg = this.isCardNumError? '請輸入正確信用卡號': '';
				return;
			}
			let result = await billCreditCardApi.changeCardValidDate(this.cardNumber, this.cardType, this.selectYear + this.selectMonth);
			if(result){
				this.$router.push({name:'bill-credit-card-success'});
				return;
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/billCreditCard/billCreditCard.js